const masterActions = {
    GET_PROJECT_LIST: 'GET_PROJECT_LIST',
    SET_PROJECT_LIST: 'SET_PROJECT_LIST',
    CREATE_PROJECT: 'CREATE_PROJECT',
    UPDATE_PROJECT: 'UPDATE_PROJECT',
    SET_GRIEVANCE : 'SET_GRIEVANCE',
    GET_GRIEVANCE : 'GET_GRIEVANCE',
    BULK_UPLOAD_GENDER_MASTER : 'BULK_UPLOAD_GENDER_MASTER',
    SET_POST_MASTERS_STATUS:"SET_POST_MASTERS_STATUS",


    GET_COURSE_LIST: 'GET_COURSE_LIST',
    GET_COURSE_LIST_BY_ADMIN: 'GET_COURSE_LIST_BY_ADMIN',
    SET_COURSE_LIST_BY_ADMIN: 'SET_COURSE_LIST_BY_ADMIN',
    SET_COURSE_LIST: 'SET_COURSE_LIST',
    CREATE_COURSE: 'CREATE_COURSE',
    UPDATE_COURSE: 'UPDATE_COURSE',
    SET_ACTIVE_COURSE: 'SET_ACTIVE_COURSE',
    GET_ALL_BATCH: 'GET_ALL_BATCH',
    SET_ALL_BATCH: 'SET_ALL_BATCH',
    GET_OTBS_COURSE_LIST : 'GET_OTBS_COURSE_LIST',
    SET_OTBS_COURSE_LIST : 'SET_OTBS_COURSE_LIST',

    SET_MASTERS_STATUS: 'SET_MASTERS_STATUS',
    GET_COURSE_CANDIDATE_LIST: 'GET_COURSE_CANDIDATE_LIST',
    SET_COURSE_CANDIDATE_LIST:'SET_COURSE_CANDIDATE_LIST',
    SET_ADMITCARD_DOWNLOAD_LIST:'SET_ADMITCARD_DOWNLOAD_LIST',
    GET_ADMITCARD_DOWNLOAD_LIST:'GET_ADMITCARD_DOWNLOAD_LIST',
    SET_SCORECARD_DOWNLOAD_LIST:'SET_SCORECARD_DOWNLOAD_LIST',
    GET_SCORECARD_DOWNLOAD_LIST:'GET_SCORECARD_DOWNLOAD_LIST',
    
    GET_TEMPLATE_LIST:' GET_TEMPLATE_LIST',
    SET_TEMPLATE_LIST:'SET_TEMPLATE_LIST',
    UPDATE_TEMPLATE:'UPDATE_TEMPLATE',
    SET_ACTIVE_TEMPLATE: 'SET_ACTIVE_TEMPLATE',
    GET_MASTER_TEMPLATE_NAME: 'GET_MASTER_TEMPLATE_NAME',
    SET_MASTER_TEMPLATE_NAME: 'SET_MASTER_TEMPLATE_NAME',
    GET_META_DATA:'GET_META_DATA',
    SET_META_DATA:'SET_META_DATA',

    GET_ACTIVE_COURSES: 'GET_ACTIVE_COURSES',
    SET_ACTIVE_COURSES: 'SET_ACTIVE_COURSES',

    CREATE_OJECTION_LIST: 'CREATE_OJECTION_LIST',
    UPDATE_OJECTION_LIST: 'UPDATE_OJECTION_LIST',
    GET_OJECTION_LIST: 'GET_OJECTION_LIST',
    SET_OJECTION_LIST: 'SET_OJECTION_LIST',
};

export default masterActions;

     